export default __webpack_public_path__ + "static/media/medal_black.b12d493f.svg";